const tabTypes = {
  door: 'door',
  glass: 'glass',
  woody: 'woody',
  wall: 'wall',
};

export default tabTypes;
